/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Personal_Info_Desired_Positions_HintInputs */

const en_register_onboarding_personal_info_desired_positions_hint = /** @type {(inputs: Register_Onboarding_Personal_Info_Desired_Positions_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select the desired types of employment.`)
};

const de_register_onboarding_personal_info_desired_positions_hint = /** @type {(inputs: Register_Onboarding_Personal_Info_Desired_Positions_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle die gewünschten Beschäftigungsarten.`)
};

/**
* | output |
* | --- |
* | "Select the desired types of employment." |
*
* @param {Register_Onboarding_Personal_Info_Desired_Positions_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_personal_info_desired_positions_hint = /** @type {((inputs?: Register_Onboarding_Personal_Info_Desired_Positions_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Personal_Info_Desired_Positions_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_personal_info_desired_positions_hint(inputs)
	return en_register_onboarding_personal_info_desired_positions_hint(inputs)
});